<template>
    <b-form-select :value="value" @input="$emit('input', $event)" size="sm" :disabled="disabled">
        <b-form-select-option :value="null">{{ noneText }}</b-form-select-option>
        <b-form-select-option v-for="s in schedules" :key="s.id" :value="s.id">{{ s.name }}</b-form-select-option>
    </b-form-select>
</template>

<script lang="ts">
import axios from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

interface PriceScheduleOption { id: number; name: string; }

// Fetches /api/PriceSchedule (active-only by default) and exposes it as a b-form-select.
// The auto-process row's `defaultCashOut` field is actually a PriceSchedule.Id, not a
// dollar amount — worker code: `priceScheduleId = product.defaultCashOut ?? program.PriceSchedule.Id ?? 1`.
// Replacing the bare numeric input with this dropdown removes the "memorize the id"
// step operators were previously asked to do.
@Component({ name: 'PriceScheduleSelect' })
export default class PriceScheduleSelect extends Vue {
    @Prop({ default: null }) value!: number | null;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: 'Program Default' }) noneText!: string;

    private schedules: PriceScheduleOption[] = [];

    async created() {
        try {
            const resp = await axios.get<PriceScheduleOption[]>('/api/PriceSchedule');
            this.schedules = resp.data ?? [];
        } catch (e) {
            this.schedules = [];
            (this as any).$notifications?.notify(NotificationOptions.error(e));
        }
    }
}
</script>
